import React from 'react';
import { StyleSheet, View } from 'react-native';
import Icon from '@/components/Icon';
import Text from '@/components/Typography/Text';
import { useTheme } from '@/context/ThemeContext';

const styles = StyleSheet.create({
  quoteContainer: {
    paddingHorizontal: 5,
    paddingVertical: 8,
    borderRadius: 20,
    gap: 8,
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  quoteIconContainer: {
    flexDirection: 'row',
    paddingTop: 3,
    alignItems: 'center',
  },
});

function MessageQuote({ quoteContent }) {
  const { colors } = useTheme();

  return (
    <View style={styles.quoteContainer}>
      <View style={styles.quoteIconContainer}>
        <Icon 
          name="arrow-turn-down-right" 
          size={12} 
          color={colors.text_color_tertiary} 
        />
      </View>
      <Text size='s' color='tertiary'>{quoteContent}</Text>
    </View>
  );
}

export default React.memo(MessageQuote);